import { SaleCategory } from "@temp/components";
import { perPage } from "@temp/constants";
import * as React from "react";
import { useParams } from "react-router-dom";
var PRODUCTS_PER_PAGE = +perPage;
export var SaleCategoryContent = function SaleCategoryContent(_ref) {
  var data = _ref.data,
      loading = _ref.loading,
      loadMore = _ref.loadMore;

  var _useParams = useParams(),
      id = _useParams.id,
      redirect = _useParams.redirect;

  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };

  return React.createElement(SaleCategory, {
    data: data,
    loading: loading,
    id: id,
    redirect: redirect && true,
    loadMore: loadMore,
    PRODUCTS_PER_PAGE: PRODUCTS_PER_PAGE
  });
};
export default SaleCategoryContent;